/**
 * "Newly-arrived" job detection for the scheduler (WRK-5718 follow-up). A job
 * that landed in the planning list recently — tracked by the backend bumping
 * `updated_time` when a work order is accepted into "Ready for Planning" — is
 * flagged so its card gets the orange highlight + "NEW" badge in the
 * unscheduled list, making just-arrived work easy to spot in the A-Z list.
 */

/** Jobs whose tracked timestamp falls within this many hours are "new". */
export const NEW_JOB_WINDOW_HOURS = 24;

/**
 * True when `timestamp` (an ISO string from the API) falls within the last
 * `windowHours`, relative to `now`. Returns false for missing, future, or
 * unparseable timestamps so a bad value never spuriously highlights a job.
 */
export function isWithinRecentWindow(
  timestamp: string | null | undefined,
  now: Date,
  windowHours: number = NEW_JOB_WINDOW_HOURS,
): boolean {
  if (!timestamp) return false;

  const ts = new Date(timestamp).getTime();
  if (Number.isNaN(ts)) return false;

  const nowMs = now.getTime();
  const windowMs = windowHours * 60 * 60 * 1000;
  return ts > nowMs - windowMs && ts <= nowMs;
}
